module.exports = function _of(x) { return [x]; };



//////////////////
// WEBPACK FOOTER
// ./~/coact/~/ramda/src/internal/_of.js
// module id = 1600
// module chunks = 0